module.exports = __webpack_public_path__ + "img/paper.09ef06bb.svg";